import type { App } from 'vue'
import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'
import remainingRouter from './modules/remaining'

// 创建路由实例
const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_PATH), // createWebHashHistory URL带#，createWebHistory URL不带#
  strict: true,
  routes: remainingRouter as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

const staticRouteNames = new Set<string>()
const collectStaticRouteNames = (routes: RouteRecordRaw[]) => {
  routes.forEach((route) => {
    if (typeof route.name === 'string') {
      staticRouteNames.add(route.name)
    }
    if (route.children?.length) {
      collectStaticRouteNames(route.children)
    }
  })
}
collectStaticRouteNames(remainingRouter as RouteRecordRaw[])

export const resetRouter = (): void => {
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (typeof name === 'string' && !staticRouteNames.has(name)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
